import _ from 'lodash';
import { basicURL as serverURI } from '../../../../apiConfig.js';
const emptyImg = require('../../../../../../public/images/Exports/empty-placeholder.svg');
let msisdnToPhone = (msisdn) => {
        try {
            msisdn += ""; // TURNS IT INTO A STRING
            let regExp = /(\d{3})(\d{3})(\d{4})$/;
            let conform = msisdn.match(regExp)
            return '(' + conform[1] + ') ' + conform[2] + '-' + conform[3];
        }
        catch (e) {
            return msisdn;
        }
    },
    mb2gb = mbNumber => {
        return (mbNumber / 1024).toFixed(2) + ' GB'
    },
        altanFixLabel = str => {
            let matrix = [
                { str: 'Best Effort', replace: 'Mejor disponible' },
                { str: /subscriber[ ]does[ ]not[ ]exist/, replace: 'El número no está con Blackfon®' },
            ];
            let foundIndex = _.findIndex(matrix, item => {
                return (
                    (_.isRegExp(item.str) && item.str.test(_.trim(str)))
                    || (item.str == _.trim(str))
                )
            })
            if (foundIndex != -1) {
                return matrix[foundIndex].replace
            } else {
                return str
            }
        },
        suscriptionStatusReNamer = str => {
            if (_.trim(str) === "Nueva") {
                return "Finalización pendiente";
            }
            return str;
        },
        makeImage = (img, cfg) => {
            // let serverURI = 'http://localhost:8001/blackfon-api/index.php?r=';
            if (img) {
                let imgURI = serverURI + 'img/render/' + img;
                if (cfg) {
                    imgURI += '/' + cfg + '/img.jpg';
                }
                return imgURI;
            } else {
                return emptyImg;
            }
        }

    export {
        msisdnToPhone,
        altanFixLabel,
        suscriptionStatusReNamer,
        mb2gb,
        makeImage
    }